import gql from "graphql-tag";

export const pageFragment = gql`
  fragment PageFields on Page {
    __typename
    sys {
      id
      publishedAt
      firstPublishedAt
    }
    title
    slug
    content
  }
`;

export const categoryFragment = gql`
  fragment CategoryFields on Category {
    __typename
    sys {
      id
      publishedAt
      firstPublishedAt
    }
    name
    slug
  }
`;

export const authorFragment = gql`
  fragment AuthorFields on Author {
    __typename
    sys {
      id
      publishedAt
      firstPublishedAt
    }
    name
    slug
    profilePicture {
      title
      description
      url
      width
      height
    }
  }
`;

export const articleStubFragment = gql`
  ${categoryFragment}
  fragment ArticleStubFields on Article {
    __typename
    sys {
      id
      publishedAt
      firstPublishedAt
    }
    title
    slug
    headlines
    shortHeadline
    primaryImages: primaryImagesCollection(limit: 6) {
      total
      skip
      limit
      items {
        title
        url
        width
        height
      }
    }
    primaryAttributedImagesCollection(limit: 6) {
      total
      skip
      limit
      items {
        sys {
          id
          publishedAt
          firstPublishedAt
        }
        title
        image {
          title
          url
          width
          height
        }
        caption {
          json
        }
        attribution {
          json
        }
      }
    }
    metadata: contentfulMetadata {
      tags {
        id
        name
      }
    }
    mostReadRank
    categories: categoriesCollection(limit: 1) {
      total
      skip
      limit
      items {
        ...CategoryFields
      }
    }
    webPromoStartDate
    webPromoEndDate
  }
`;

export const articleFragment = gql`
  ${authorFragment}
  ${articleStubFragment}
  ${categoryFragment}
  fragment ArticleFields on Article {
    ...ArticleStubFields
    kicker
    description {
      json
    }
    adConfig
    articleType {
      name
      slug
      adConfig
    }
    publishDateOverride
    updateDateOverride
    authors: authorsCollection(limit: 3) {
      total
      skip
      limit
      items {
        ...AuthorFields
      }
    }
  }
`;

export const articleExtended = gql`
  ${articleFragment}
  fragment ArticleExtended on Article {
    ...ArticleFields
    content
  }
`;

export const regulatoryPageFragment = gql`
  fragment RegulatoryPageFields on RegulatoryPage {
    __typename
    sys {
      id
      publishedAt
      firstPublishedAt
    }
    title
    slug
    brand
    content
    hideTitle
  }
`;
